import { render } from "./TextareaField.vue?vue&type=template&id=062572a4&scoped=true&ts=true"
import script from "./TextareaField.vue?vue&type=script&lang=ts"
export * from "./TextareaField.vue?vue&type=script&lang=ts"

import "./TextareaField.vue?vue&type=style&index=0&id=062572a4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hekate/hekate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062572a4"]])

export default __exports__